import { spaceClient, spaceClientFor } from './client';

export const getCharitiesForSpace = (spaceId) =>
  spaceClientFor(spaceId).get('/cms/charities').then((r) => r.data);

export const createCharity = (payload) =>
  spaceClient.post('/charities', payload);

export const getCharities = () =>
  spaceClient.get('/cms/charities').then((r) => r.data);

export const getCharitysById = (id, spaceId) =>
  (spaceId ? spaceClientFor(spaceId) : spaceClient).get(`/cms/charities/${id}`).then((r) => r.data);

export const updateCharity = (charityId, payload) =>
  spaceClient.put(`/charities/${charityId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.data);

export const deleteCharity = (charityId) =>
  spaceClient.delete(`/charities/${charityId}`);
